import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { ActionTypes } from '@appStore/learning/actions';
import * as actions from '@appStore/learning/actions';
import { InformationVideosService } from '@appStore/learning/services/information-videos.service';

@Injectable()
export class InformationVideosEffects {
  constructor(private informationVideosService: InformationVideosService, private actions$: Actions) {}

  loadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.InformationVideosLoad),
      exhaustMap(action => {
        return this.informationVideosService.getInformationVideos().pipe(
          map(informationVideo => new actions.InformationVideosLoadSuccess(informationVideo)),
          catchError(error => of(new actions.InformationVideosLoadFail(error)))
        );
      })
    );
  });
  
}
